<div
  class="custom-header px-[15px]"
  style="display: flex; align-items: center"
  [ngClass]="{
    'cursor-pointer': params.enableSorting,
  }"
  (click)="toggleSort()"
>
  <div class="grow text-center">
    <span
      class="px-0"
      [ngClass]="{
        'btn--hyperlink cursor-pointer text-aux-blue': showAsLink(),
      }"
      [attr.data-pendo-id]="params.pendoTag"
      (click)="onLinkClicked($event)"
    >
      {{ params.displayName }}
    </span>
  </div>

  @if (params.enableSorting) {
    <ng-container>
      <span class="ag-sort-indicator-container">
        @if (currentSort() === 'asc') {
          <span class="ag-sort-indicator-icon ag-sort-ascending-icon" aria-hidden="true">
            <span class="ag-icon ag-icon-asc" role="presentation"></span>
          </span>
        }
        @if (currentSort() === 'desc') {
          <span class="ag-sort-indicator-icon ag-sort-descending-icon" aria-hidden="true">
            <span class="ag-icon ag-icon-desc" role="presentation"></span>
          </span>
        }
      </span>
    </ng-container>
  }
</div>
